<template>
  <div class="card">
    <div class="toolbar">
      <select v-model="query.brand" @change="onBrandChange">
        <option value="">全部品牌</option>
        <option v-for="item in brandOptions" :key="item" :value="item">{{ item }}</option>
      </select>
      <select v-model="query.model_name" @change="onModelChange">
        <option value="">全部型号</option>
        <option v-for="item in modelOptions" :key="item" :value="item">{{ item }}</option>
      </select>
      <select v-model="query.capacity" @change="onCapacityChange">
        <option value="">全部容量</option>
        <option v-for="item in capacityOptions" :key="item" :value="item">{{ item }}</option>
      </select>
      <select v-model.number="query.tenor_months">
        <option value="">全部期数</option>
        <option v-for="item in tenorOptions" :key="item" :value="item">{{ item }}期</option>
      </select>
      <button @click="fetchData">查询</button>
      <button class="primary" @click="exportCsv">导出CSV</button>
    </div>

    <table>
      <thead>
        <tr>
          <th>品牌</th>
          <th>型号</th>
          <th>容量</th>
          <th>期数</th>
          <th class="group-rent">我方总租金</th>
          <th class="group-rent">竞品最低总租金</th>
          <th class="group-rent">总租金差</th>
          <th class="group-all">我方总价</th>
          <th class="group-all">竞品最低总价</th>
          <th class="group-all">总价差</th>
          <th class="group-down">我方首付</th>
          <th class="group-down">竞品最低首付</th>
          <th class="group-down">首付差</th>
          <th>建议</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(row, idx) in list" :key="idx" :class="{ danger: Number(row.is_higher_than_market) === 1 }">
          <td>{{ row.brand }}</td>
          <td>{{ row.model_name }}</td>
          <td>{{ row.capacity || '-' }}</td>
          <td>{{ row.tenor_months }}</td>
          <td class="group-rent">{{ row.own_total_price }}</td>
          <td class="group-rent">{{ formatWithMerchant(row.market_min_total_price, row.market_min_total_price_merchant) }}</td>
          <td class="group-rent">{{ row.total_diff }}</td>
          <td class="group-all">{{ row.own_all_price }}</td>
          <td class="group-all">{{ formatWithMerchant(row.market_min_all_price, row.market_min_all_price_merchant) }}</td>
          <td class="group-all">{{ row.all_price_diff }}</td>
          <td class="group-down">{{ row.own_down_payment }}</td>
          <td class="group-down">{{ formatWithMerchant(row.market_min_down_payment, row.market_min_down_payment_merchant) }}</td>
          <td class="group-down">{{ row.down_payment_diff }}</td>
          <td>{{ Number(row.is_higher_than_market) === 1 ? '优先调价' : '可保持' }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { compareList, dictBrands, dictModels, dictCapacities, dictTenors } from '@/api/priceMonitor'

export default {
  name: 'ComparePanel',
  data() {
    return {
      query: { brand: '', model_name: '', capacity: '', tenor_months: '' },
      list: [],
      brandOptions: [],
      modelOptions: [],
      allCapacities: [],
      capacityOptions: [],
      tenorOptions: []
    }
  },
  async created() {
    await this.loadBrands()
    await this.loadCapacities(true)
    await this.loadTenors()
    this.fetchData()
  },
  methods: {
    formatWithMerchant(price, merchant) {
      const m = (merchant || '').trim()
      return m ? `${price}（${m}）` : `${price}`
    },
    async loadBrands() {
      const res = await dictBrands({})
      if (res.code === 200) {
        this.brandOptions = (res.data && res.data.list) || []
      }
    },
    async loadModels() {
      const res = await dictModels({ brand: this.query.brand || '' })
      if (res.code === 200) {
        this.modelOptions = (res.data && res.data.list) || []
      } else {
        this.modelOptions = []
      }
    },
    async loadCapacities(isInit = false) {
      const res = await dictCapacities({ brand: this.query.brand || '', model_name: this.query.model_name || '' })
      if (res.code === 200) {
        const list = (res.data && res.data.list) || []
        if (isInit) {
          this.allCapacities = [...list]
        }
        this.capacityOptions = list.length ? list : [...this.allCapacities]
      } else {
        this.capacityOptions = [...this.allCapacities]
      }
    },
    async loadTenors() {
      const res = await dictTenors({
        brand: this.query.brand || '',
        model_name: this.query.model_name || '',
        capacity: this.query.capacity || ''
      })
      if (res.code === 200) {
        this.tenorOptions = (res.data && res.data.list) || []
      } else {
        this.tenorOptions = []
      }
      if (this.query.tenor_months && !this.tenorOptions.includes(Number(this.query.tenor_months))) {
        this.query.tenor_months = ''
      }
    },
    async onBrandChange() {
      this.query.model_name = ''
      this.query.capacity = ''
      this.query.tenor_months = ''
      this.modelOptions = []
      this.capacityOptions = []
      if (this.query.brand) {
        await this.loadModels()
      }
      await this.loadCapacities()
      await this.loadTenors()
    },
    async onModelChange() {
      this.query.capacity = ''
      this.query.tenor_months = ''
      this.capacityOptions = []
      await this.loadCapacities()
      await this.loadTenors()
    },
    async onCapacityChange() {
      this.query.tenor_months = ''
      await this.loadTenors()
    },
    async fetchData() {
      const res = await compareList(this.query)
      if (res.code === 200) {
        this.list = res.data.list || []
      } else {
        alert(res.msg || '查询失败')
      }
    },
    exportCsv() {
      const headers = ['品牌', '型号', '容量', '期数', '我方总租金', '竞品最低总租金', '总租金差', '我方总价', '竞品最低总价', '总价差', '我方首付', '竞品最低首付', '首付差', '建议']
      const lines = this.list.map(row =>
        [
          row.brand,
          row.model_name,
          row.capacity || '',
          row.tenor_months,
          row.own_total_price,
          this.formatWithMerchant(row.market_min_total_price, row.market_min_total_price_merchant),
          row.total_diff,
          row.own_all_price,
          this.formatWithMerchant(row.market_min_all_price, row.market_min_all_price_merchant),
          row.all_price_diff,
          row.own_down_payment,
          this.formatWithMerchant(row.market_min_down_payment, row.market_min_down_payment_merchant),
          row.down_payment_diff,
          Number(row.is_higher_than_market) === 1 ? '优先调价' : '可保持'
        ].join(',')
      )
      const csv = [headers.join(','), ...lines].join('\n')
      const blob = new Blob([`\uFEFF${csv}`], { type: 'text/csv;charset=utf-8;' })
      const link = document.createElement('a')
      link.href = URL.createObjectURL(blob)
      link.download = `我方差价对比_${Date.now()}.csv`
      link.click()
      URL.revokeObjectURL(link.href)
    }
  }
}
</script>

<style scoped>
.card { background: #fff; border-radius: 8px; padding: 16px; }
.toolbar { display: flex; gap: 10px; margin-bottom: 12px; }
select, button { height: 34px; padding: 0 10px; border: 1px solid #d1d5db; border-radius: 6px; }
button { cursor: pointer; background: #fff; }
button.primary { background: #2563eb; color: #fff; border-color: #2563eb; }
table { width: 100%; border-collapse: collapse; }
th, td { border: 1px solid #e5e7eb; padding: 8px; font-size: 13px; text-align: left; }
.group-rent { background: #eff6ff; color: #1e3a8a; }
.group-all { background: #f0fdf4; color: #166534; }
.group-down { background: #fff7ed; color: #9a3412; }
.danger { background: #fef2f2; color: #b91c1c; font-weight: 600; }
</style>
